<template>
<b-form-group
  id="multiple-weighted-text-rn2o6t"
  :label="properties.label"
>
    <div id="multiple-weighted-text-ycjucz" class="border rounded border-color-light-gray">
      <div id="multiple-weighted-text-0q2xck" class="bg-light-gray py-2 px-3">
        <b-form-textarea id="multiple-weighted-text-lsm76h" v-model="form.text" rows="4" no-resize class="mb-2" :errors="formErrors.text" :placeholder="properties.placeholders.textarea"></b-form-textarea>
        <b-input-group id="multiple-weighted-text-pfm4ev" class="d-flex">
          <template v-slot:append>
            <b-button id="multiple-weighted-text-w45vjy" size="sm" variant="primary" class="text-white" style @click="addWeightedText">
              Add
            </b-button>
          </template>
          <b-input id="multiple-weighted-text-cqyj2x" type="number" v-model="form.value" size="sm" :errors="formErrors.vaule" :placeholder="properties.placeholders.input"></b-input>
        </b-input-group>
      </div>
      <div id="multiple-weighted-text-xgjgz5" class="texts-list-container">
        <b-list-group id="multiple-weighted-text-54z0am" v-if="value.length > 0" class="mt-1 p-1 forms-list">
          <draggable id="multiple-weighted-text-q0op2g" v-model="propertyValue">
            <b-list-group-item class="filter-value border pl-2 pr-2 pt-1 pb-1 mr-2 ml-1 mt-2" v-for="({ text, value }, index) in value" :key="index" :id="'multiple-weighted-text-thyvyx-' + index">
              <div :id="'multiple-weighted-text-8ora17-' + index">
                <b-icon-grip-horizontal :id="'multiple-weighted-text-z5pej9-' + index"></b-icon-grip-horizontal>
                {{ text }} ({{ value }})
              </div>
              <img class="filter-value-delete" :src="require('../../../assets/icons/close-circle.png')" @click="removeText(index)" :id="'multiple-weighted-text-aygeht-' + index" />
            </b-list-group-item>
          </draggable>
        </b-list-group>
        <div id="multiple-weighted-text-si3rzf" v-else class="text-center color-custom-dark-grey m-1">
          No items selected.
        </div>
      </div>
    </div>
  </b-form-group>

</template>

<script>
import Draggable from "vuedraggable";

export default {
  name: "MultipleWeightedTextPropertyType",
  components: { Draggable },
  props: ["properties", "property", "value"],
  data() {
    return {
      form: {
        text: "",
        value: ""
      },
      formErrors: {
        text: [],
        value: []
      }
    };
  },
  methods: {
    addWeightedText() {
      if (this.form.text.trim() && this.form.value) {
        const newWeightedTexts = [...this.value];
        newWeightedTexts.push({
          text: this.form.text,
          value: parseFloat(this.form.value)
        });
        this.$emit("update-value", this.property, newWeightedTexts);
        this.form = { text: "", value: "" };
      }
    },
    removeText(itemIndex) {
      const newValue = [...this.value];
      newValue.splice(itemIndex, 1);
      this.$emit("update-value", this.property, newValue);
    }
  },
  computed: {
    propertyValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("update-value", this.property, newValue);
      }
    }
  }
};
</script>

<style scoped>
.texts-list-container {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
.filter-value {
  position: relative;
  min-width: 50px;
  color: #a6a6a6;
  font-size: 14px;
}
.filter-value-delete {
  position: absolute;
  top: -8px;
  right: -8px;
}
.filter-value-delete:hover {
  cursor: pointer;
}
</style>
